import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2754b6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Onderwerp "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gewenste oplossing", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Foto's", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Project "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bouwnummer", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Leverancier", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Medewerker", -1))

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { issueStore } from '@/stores/issue'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'

type Option = { id:number, name?:string, full_name?:string, number_with_address?:string }


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueConceptEditCard',
  setup(__props, { expose }) {

const router = useRouter()
const saving = ref(false)
const loading = ref({ projects: false, buildings: false, companies: false, solvers: false, media: false })
const projects = ref<Option[]>([])
const buildings = ref<Option[]>([])
const companies = ref<Option[]>([])
const solvers = ref<Option[]>([])
const form = ref({
  title: '',
  description: '',
  recommended_solution: '',
  project_id: null as number|null,
  building_id: null as number|null,
  solver_company_id: null as number|null,
  solver_id: null as number|null
})

onMounted(() => {
  hydrateForm()
  getProjects()
  getCompanies()
  if (form.value.project_id) getBuildings()
  if (form.value.solver_company_id) getSolvers()
})

const canSave = computed(() => {
  return !!(form.value.title && form.value.description && form.value.project_id)
})

function hydrateForm () : void {
  const issue = issueStore().issue
  if (!issue) return

  form.value = {
    title: issue.title || '',
    description: issue.description || '',
    recommended_solution: issue.recommended_solution || '',
    project_id: issue.project_id || issue.project?.id || null,
    building_id: issue.building_id || issue.building?.id || null,
    solver_company_id: issue.solver_company_id || issue.solver_company?.id || null,
    solver_id: issue.solver_id || issue.solver?.id || null
  }
}

function getProjects () : void {
  loading.value.projects = true
  axios.get(process.env.VUE_APP_API_URL + '/projects?limit=1000&sort=name').then((r) => {
    projects.value = r.data.data
  }).finally(() => {
    loading.value.projects = false
  })
}

function projectChanged () : void {
  form.value.building_id = null
  buildings.value = []
  getBuildings()
}

function getBuildings () : void {
  if (!form.value.project_id) return

  loading.value.buildings = true
  axios.get(process.env.VUE_APP_API_URL + '/projects/' + form.value.project_id + '/buildings').then((r) => {
    const responseBuildings = r.data.data || r.data
    buildings.value = responseBuildings.map((building: Option & { address?: string, zipcode?: string, city?: string, number?: string|number }) => ({
      ...building,
      number_with_address: building.number_with_address || (building.address ? `${building.number} - ${building.address}, ${building.zipcode || ''} ${building.city || ''}` : building.number)
    }))
  }).finally(() => {
    loading.value.buildings = false
  })
}

function getCompanies () : void {
  loading.value.companies = true
  axios.get(process.env.VUE_APP_API_URL + '/companies?limit=2500&sort=name').then((r) => {
    companies.value = r.data.data
  }).finally(() => {
    loading.value.companies = false
  })
}

function solverCompanyChanged () : void {
  form.value.solver_id = null
  solvers.value = []
  getSolvers()
}

function getSolvers () : void {
  if (!form.value.solver_company_id) return

  loading.value.solvers = true
  axios.get(process.env.VUE_APP_API_URL + '/companyUsers?filter[company.id]=' + form.value.solver_company_id + '&limit=2500&sort=firstname').then((r) => {
    solvers.value = r.data.data
  }).finally(() => {
    loading.value.solvers = false
  })
}

function saveConcept () : void {
  if (!canSave.value || !issueStore().issue) return

  saving.value = true
  const solversPayload = form.value.solver_company_id
    ? [{ company_id: form.value.solver_company_id, user_id: form.value.solver_id, status: 2 }]
    : []

  axios.put(process.env.VUE_APP_API_URL + '/issues/' + issueStore().issue.id, {
    title: form.value.title,
    description: form.value.description,
    recommended_solution: form.value.recommended_solution,
    project_id: form.value.project_id,
    building_id: form.value.building_id,
    solver_company_id: form.value.solver_company_id,
    solver_id: form.value.solver_id,
    solvers: solversPayload
  }).then(() => {
    notification.success({
      message: 'Servicemelding opgeslagen!',
      description: 'De concept-servicemelding is succesvol opgeslagen.'
    })
    router.push({ name: 'Issues' })
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens opslaan!',
      description: 'Er is iets mis gegaan tijdens het opslaan van de servicemelding.'
    })
  }).finally(() => {
    saving.value = false
  })
}

function addIssueMedia (file:File) : void {
  if (!issueStore().issue || loading.value.media) return

  loading.value.media = true
  const formData = new FormData()
  formData.append('files[]', file)

  axios.post(process.env.VUE_APP_API_URL + '/issues/' + issueStore().issue.id + '/media', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    issueStore().issue = r.data.data || r.data
  }).finally(() => {
    loading.value.media = false
  })
}

function deleteIssueMedia (file:{ id:number }) : void {
  if (!issueStore().issue) return

  axios.delete(process.env.VUE_APP_API_URL + '/issues/' + issueStore().issue.id + '/media/' + file.id).then((r) => {
    issueStore().issue = r.data.data || r.data
  })
}

function filterByLabel (input:string, option?:{ label?: string, name?: string, full_name?: string, number_with_address?: string, number?: string|number }) : boolean {
  const searchValue = [
    option?.label,
    option?.name,
    option?.full_name,
    option?.number_with_address,
    option?.number
  ]
    .filter(value => value !== undefined && value !== null)
    .join(' ')

  return searchValue.toLowerCase().includes(input.toLowerCase())
}

// eslint-disable-next-line no-undef
expose({
  canSave,
  saveConcept,
  saving
})

return (_ctx: any,_cache: any) => {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_col, {
      xs: {span: 24},
      lg: {span: 16}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          title: "Concept aanvullen",
          bordered: false
        }, {
          default: _withCtx(() => [
            (!_unref(issueStore)().issue)
              ? (_openBlock(), _createBlock(_component_a_skeleton, {
                  key: 0,
                  active: ""
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_alert, {
                    message: "Deze concept-servicemelding is alleen zichtbaar voor jou en beheerders.",
                    type: "info",
                    "show-icon": "",
                    style: {"margin-bottom":"16px"}
                  }),
                  _createVNode(_component_a_row, { gutter: [16, 16] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(_component_a_input, {
                            value: form.value.title,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _createVNode(_component_a_textarea, {
                            value: form.value.description,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.description) = $event)),
                            rows: 4
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_component_a_textarea, {
                            value: form.value.recommended_solution,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.recommended_solution) = $event)),
                            rows: 4
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createVNode(Uploader, {
                            "current-count": _unref(issueStore)().issue.files.length,
                            "allowed-extensions": ['png', 'jpg', 'jpeg', 'webp'],
                            "upload-button": "",
                            onNewFileUploaded: addIssueMedia
                          }, null, 8, ["current-count"]),
                          _createVNode(Filelist, {
                            media: _unref(issueStore)().issue.files,
                            "can-delete": true,
                            onDeleteFile: deleteIssueMedia
                          }, null, 8, ["media"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            loading: saving.value,
                            disabled: !_unref(canSave) || saving.value,
                            onClick: saveConcept
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Opslaan")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"]),
                          _createVNode(_component_a_button, {
                            style: {"margin-left":"8px"},
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({ name: 'Issues' })))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Terug naar overzicht")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_col, {
      xs: {span: 24},
      lg: {span: 8}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          title: "Gegevens",
          bordered: false,
          class: "concept-sidebar-card"
        }, {
          default: _withCtx(() => [
            (!_unref(issueStore)().issue)
              ? (_openBlock(), _createBlock(_component_a_skeleton, {
                  key: 0,
                  active: ""
                }))
              : (_openBlock(), _createBlock(_component_a_row, {
                  key: 1,
                  gutter: [16, 16]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createVNode(_component_a_select, {
                          value: form.value.project_id,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.project_id) = $event)),
                          loading: loading.value.projects,
                          "field-names": { label: 'name', value: 'id' },
                          "filter-option": filterByLabel,
                          options: projects.value,
                          "show-search": "",
                          onChange: projectChanged
                        }, null, 8, ["value", "loading", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createVNode(_component_a_select, {
                          value: form.value.building_id,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.building_id) = $event)),
                          loading: loading.value.buildings,
                          disabled: !form.value.project_id || loading.value.buildings,
                          "field-names": { label: 'number_with_address', value: 'id' },
                          "filter-option": filterByLabel,
                          options: buildings.value,
                          "allow-clear": "",
                          "show-search": ""
                        }, null, 8, ["value", "loading", "disabled", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_component_a_select, {
                          value: form.value.solver_company_id,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.solver_company_id) = $event)),
                          loading: loading.value.companies,
                          "field-names": { label: 'name', value: 'id' },
                          "filter-option": filterByLabel,
                          options: companies.value,
                          "allow-clear": "",
                          "show-search": "",
                          onChange: solverCompanyChanged
                        }, null, 8, ["value", "loading", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createVNode(_component_a_select, {
                          value: form.value.solver_id,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.solver_id) = $event)),
                          loading: loading.value.solvers,
                          disabled: !form.value.solver_company_id || loading.value.solvers,
                          "field-names": { label: 'full_name', value: 'id' },
                          "filter-option": filterByLabel,
                          options: solvers.value,
                          "allow-clear": "",
                          "show-search": ""
                        }, null, 8, ["value", "loading", "disabled", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})